import React, { useEffect } from 'react'; 
import { Book, Check } from 'lucide-react'; 
import { useFormOptions } from '../../config/constants';


const SelectorTipoServicios = ({serviciosSeleccionados = [], formData, setFormData}) => {
  
  const { tipoServiciosList } = useFormOptions();

  useEffect(() => {
    // Verificamos si hay servicios seleccionados y si formData existe
    if (serviciosSeleccionados && serviciosSeleccionados.length > 0) {
      setFormData(prevData => ({
        ...prevData,
        tipoServicios: serviciosSeleccionados
      }));
    }
  }, [serviciosSeleccionados, setFormData]);

  return(
    <div className="space-y-6">
      <div className="flex items-center text-xl font-bold text-gray-800 mb-4">
        <Book className="mr-3 w-6 h-6 text-blue-500" />
        Tipos de Servicios
      </div>
                    
      <p className="text-gray-600 mb-4">
        Selecciona los tipos de servicios que ofreces como tutor.
      </p>
                    
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {tipoServiciosList.map((servicio, index) => (
          <div
            key={index}
            className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-blue-50 hover:border-blue-200 transition-colors"
            onClick={() => {

              const serviciosActualizados = [...formData.tipoServicios];
              if (serviciosActualizados.includes(servicio)) {
                const idx = serviciosActualizados.indexOf(servicio);
                serviciosActualizados.splice(idx, 1);
              } else {
              serviciosActualizados.push(servicio);
              }
                setFormData({...formData, tipoServicios: serviciosActualizados});
            }}
          >
            <div className={`w-6 h-6 rounded-md mr-3 flex items-center justify-center ${
             formData.tipoServicios.includes(servicio) ? 'bg-blue-500 text-white' : 'border border-gray-300'
            }`}>
            {formData.tipoServicios.includes(servicio) && <Check className="w-4 h-4" />}
          </div>
          <span className="flex-1">{servicio}</span>
        </div>
      ))}
      </div>
                    
                    
    </div>
  );

};

export default SelectorTipoServicios;